export const QUESTION_TYPES = {
  radio: 'radio',
  checkbox: 'checkbox',
  text: 'text',
  multiText: 'multiText',
  number: 'number',
  multiNumber: 'multiNumber',
  slider: 'slider',
  matrixRadio: 'matrixRadio',
  matrixCheckbox: 'matrixCheckbox',
  ranking: 'ranking',
  message: 'message',
  dragAndDrop: 'dragAndDrop',
  formula: 'formula',
}

export const TYPE_OPTIONS = {
  radio: 'Single Choice',
  checkbox: 'Multiple Choice',
  text: 'Free Text',
  multiText: 'Multiple Free Text',
  number: 'Numerical Input',
  multiNumber: 'Multiple Numerical Input',
  slider: 'Slider',
  matrixRadio: 'Matrix',
  matrixCheckbox: 'Matrix Multiple Choice',
  ranking: 'Ranking',
  message: 'Text message',
  dragAndDrop: 'Drag and Drop',
}

export const ANSWER_TYPES = {
  answers: 'answers',
  subQuestions: 'subQuestions',
}

export const UNITARY_SHIFT = 1

export const INDEX_TO_HUMAN_OFFSET = 1

export const LANGUAGES = {
  PORTUGUESE: 'pt',
  SPANISH: 'es',
  ENGLISH: 'en',
}

export const SURVEY_TYPE = {
  CAWI: 'CAWI',
  CATI: 'CATI',
  CAPI: 'CAPI',
}

export const PORTAL_NAMES = {
  MODAL_DEFAULT: 'modal-default',
}

export const LOGIC_OPTIONS = {
  NEXT: 'next',
  SCREENED: 'screened',
  FINISH: 'finish',
}
